import React from "react";
import { AuthConsumer } from "../../Context/AuthContext";
import functions from "../functions";
export const RenderSecure = ({ code, children, requireStationId = false }) => {
  return (
    <AuthConsumer>
      {(userProps) => {
        // Check AccessCode
        const hasAccess =
          code === "" ||
          functions.findInObject(userProps.permissionLists, code);
        // Check station_id only if requireStationId is true
        const stationId = localStorage.getItem("FuelFy@station_id");
        const stationCheck = requireStationId ? !!stationId : true;
        // Render children if both checks pass
        if (hasAccess && stationCheck) {
          return <>{children}</>;
        }
        return null;
      }}
    </AuthConsumer>
  );
};
